import { render } from "./elixir-button.vue?vue&type=template&id=0d4347b0"
import script from "./elixir-button.vue?vue&type=script&lang=js"
export * from "./elixir-button.vue?vue&type=script&lang=js"

import "./elixir-button.vue?vue&type=style&index=0&id=0d4347b0&lang=css"
/* custom blocks */
import block0 from "./elixir-button.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__